/* eslint-disable no-redeclare */
import { z } from 'zod';

export const GetSrcConfigurationRequestDto = z.object({
  src: z.string(),
});
export type GetSrcConfigurationRequestDto = z.infer<
  typeof GetSrcConfigurationRequestDto
>;
export const GetSrcConfigurationResponseDto = z.object({
  srcConfigurationId: z.number(),
  src: z.string(),
  logoUrl: z.string().url().optional(),
});
export type GetSrcConfigurationResponseDto = z.infer<
  typeof GetSrcConfigurationResponseDto
>;
